export default {"src":"/_next/static/media/configuration-review.4e7b6bd1.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};